import script from "./InvoiceSection2.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceSection2.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceSection2.vue?vue&type=style&index=0&id=01841d8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01841d8a"]])

export default __exports__